<template>
  <div class="ride-details-map">
    <div class="map-wrapper" :class="{ 'is-tall': tall }" id="ride-details-map">
      <div :id="mapID" class="map" />
      <span
        v-show="warning"
        class="tag is-danger warning"
        @click="fitToUserLocation"
      >
        <i class="fa fa-exclamation-triangle" />
        <span v-html="warning" style="margin-left: 6px" />
      </span>
    </div>
  </div>
</template>

<script>
import geo from "@/geo";
import L from "leaflet";
import "leaflet.locatecontrol";
import "leaflet.awesome-markers";

export default {
  name: "RideDetailsMap",
  props: {
    pickup: Object,
    dropoff: Object,
    route: String,
    showRoute: Boolean,
    tall: Boolean,
  },
  data() {
    return {
      mapID: "ride-details-map-map",
      map: null,
      warning: null,
      straightLine: null,
      layer: null, // main layer
    };
  },
  computed: {},
  mounted() {
    this.initMap();
    this.checkWarning();
  },
  methods: {
    checkWarning() {
      var user = this.$store.getters.getUserLatLon;
      var dist = geo.distanceToUserInMeters(user, this.pickup);
      if (dist < 250) return; // okay
      var pretty = Math.round(dist / 1000) + "km";
      if (dist < 999) pretty = dist + "m";
      pretty = ` <span class="has-text-weight-bold">${pretty}</span>`; // has leading space
      this.warning = this.$t("ride.pickup-far-from-current-location") + pretty; //`Pickup is far from your current location ${pretty}`;
      setTimeout(() => {
        this.fitToUserLocation();
        this.shiftMapDown();
      }, 4000);
    },
    initMap() {
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps

      this.map = L.map(this.mapID, { attributionControl: false });
      this.map.setView(this.pickup, 17);
      L.tileLayer(tilesURL, {
        tileSize: 512,
        zoomOffset: -1,
        // minZoom: 12,
        maxZoom: 19,
      }).addTo(this.map);

      this.map.zoomControl.remove();
      var position = { position: "bottomright" };
      L.control.zoom(position).addTo(this.map);

      this.layer = L.featureGroup().addTo(this.map);

      this.drawUserLocation();

      var pickupIcon = L.AwesomeMarkers.icon({
        icon: "street-view",
        markerColor: "blue",
      });

      var dropoffIcon = L.AwesomeMarkers.icon({
        icon: "flag-checkered",
        markerColor: "lightgreen",
        iconColor: "blue",
        extraClasses: "fa-lg",
      });

      // create markers, add to map and fit
      var pickupMarker = L.marker(this.pickup, { icon: pickupIcon });
      pickupMarker.addTo(this.layer);
      var dropoffMarker = L.marker(this.dropoff, { icon: dropoffIcon });
      dropoffMarker.addTo(this.layer);
      var group = new L.featureGroup([pickupMarker, dropoffMarker]);
      var padding = { padding: [50, 50] };
      this.map.fitBounds(group.getBounds(), padding);
      // this.shiftMapDown();

      // add popups
      var opts = { closeButton: false, autoPan: true };
      var pStr = this.$t("driver.pickup");
      var dStr = this.$t("driver.dropoff");
      var pickupName = this.pickup.name || this.$t("ride.pin-location");
      var dropoffName = this.dropoff.name || this.$t("ride.pin-location");
      pickupMarker.bindPopup(`<i>${pStr}</i><br>${pickupName}`, opts);
      dropoffMarker.bindPopup(`<i>${dStr}</i><br>${dropoffName}`, opts);
      setTimeout(() => pickupMarker.openPopup(), 1000);
      setTimeout(() => dropoffMarker.openPopup(), 3000);
      setTimeout(() => pickupMarker.openPopup(), 5000);

      if (this.showRoute && this.route) {
        this.drawDrivingRoute(this.route); //this.getDrivingRoute();
      } else this.drawStraightLine();
    },
    drawUserLocation() {
      var coords = this.$store.getters.getUserLatLon;
      var icon = L.divIcon({
        html: `<div class="blue-dot"></div>`,
        popupAnchor: [7, -6],
        className: "none",
      });
      this.userMarker = L.marker(coords, { icon: icon });
      this.userMarker.addTo(this.layer);
      var popupOpts = { closeButton: false, autoPan: true };
      this.userMarker.bindPopup(this.$t("ride.your-current-gps"), popupOpts);
    },
    fitToUserLocation() {
      var padding = { padding: [50, 50] };
      this.map.fitBounds(this.layer.getBounds(), padding);
      setTimeout(() => this.userMarker.openPopup(), 1000);
    },
    shiftMapDown() {
      this.map.panBy(new L.Point(0, -50), { animate: true });
    },
    drawStraightLine() {
      var dashLine = {
        color: "#0394fc",
        weight: "3",
        opacity: 0.6,
        dashArray: "6, 6",
        lineCap: "square",
      };
      var latlngs = Array();
      latlngs.push(this.pickup);
      latlngs.push(this.dropoff);
      this.straightLine = L.polyline(latlngs, dashLine).addTo(this.map);
    },
    drawDrivingRoute(encoded) {
      var polyUtil = require("polyline-encoded");
      var array = polyUtil.decode(encoded);
      var polyline = new L.polyline(array, {
        color: "#0394fc",
        weight: 5,
        opacity: 0.6,
      });
      polyline.addTo(this.map);
      var group = new L.featureGroup([polyline]);
      var padding = { padding: [50, 50] };
      this.map.fitBounds(group.getBounds(), padding);
      if (this.straightLine) this.map.removeLayer(this.straightLine); // remove the straight line
      setTimeout(() => this.shiftMapDown(), 500);
    },
    getDrivingRoute() {
      var data = {
        pickup: this.pickup,
        dropoff: this.dropoff,
      };
      this.$store
        .dispatch("drivingRoute", data)
        .then((obj) => {
          this.console("drivingRoute", obj);
          this.drawDrivingRoute(obj.encoded);
        })
        .catch((err) => {
          console.error("drivingRoute error", err);
          this.drawStraightLine();
        });
    },
  },
};
</script>

<style scoped>
.map-wrapper {
  /* position: relative; */
  position: absolute;
  /* bottom: 0; */
  left: 0;
  /* height: calc(100vh - 259px); */
  height: calc(100vh - 280px);
  width: 100vw;
  z-index: 0;
  border: 1px solid #ddd;
}
.is-tall {
  /* height: calc(100vh - 205px); */
  height: calc(100vh - 226px);
}
.map {
  position: relative;
  height: 100%;
  width: 100%;
}
.tag {
  position: absolute;
  top: 0;
  font-size: 0.8em;
  width: 100vw;
  z-index: 1101;
}
.warning.tag {
  border-radius: 0;
}
</style>

<style lang="scss">
#ride-details-map-map {
  .leaflet-control-locate {
    border-radius: 50%;
  }
  .leaflet-control-locate a {
    border-radius: 50%;
  }
  .leaflet-popup-content {
    padding: 5px 5px;
    margin: 1px 0;
    // color: rgb(23, 23, 193);
    color: rgb(23, 102, 193);
    font-size: 1.2em;
    max-width: 130px;
  }
  .leaflet-popup-content i {
    font-weight: 500;
    opacity: 0.8;
    color: grey;
  }
  .blue-dot {
    margin-left: 6px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #2693da;
    opacity: 0.9;
    border: 1px solid #feeaa4b5;
    animation: pulsate-2 3s ease-out infinite;
  }
  @keyframes pulsate-2 {
    0% {
      box-shadow: 0 0 0 1px cyan;
    }
    50% {
      box-shadow: 0 0 0 6px rgba(255, 217, 0, 0.5);
    }
    100% {
      box-shadow: 0 0 0 1px lightskyblue;
    }
  }
  @-webkit-keyframes pulsate-2 {
    0% {
      box-shadow: 0 0 0 1px cyan;
    }
    50% {
      box-shadow: 0 0 0 6px rgba(255, 217, 0, 0.5);
    }
    100% {
      box-shadow: 0 0 0 1px lightskyblue;
    }
  }
}
</style>